/** PURE_IMPORTS_START ._FromObservable PURE_IMPORTS_END */
import { FromObservable } from './FromObservable';
export var from = FromObservable.create;
//# sourceMappingURL=from.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/from.js
// module id = 223
// module chunks = 0